import { useAppDispatch, useAppSelector } from "@app/hooks";
import { selectCurrentBuilder, setCompareProjectId } from "@features/builder/builderSlice";
import { DropdownInputGroup, FieldType } from "@typedefs/modulesInterfaces";
import { Form, Formik } from "formik";
import { usePaginatedProjects } from "@hooks/index";
import GenericInputGroup from "@components/input/inputGroup/GenericInputGroup";
import TranslatableText from "@components/translations/TranslatableText";
import ProjectResults from "./ProjectResults";

const SelectProjectToCompare = () => {
  const dispatch = useAppDispatch();
  const { projectOptions, handleLoadMore, hasNextPage } = usePaginatedProjects();

  const dropdownInput: DropdownInputGroup = {
    type: FieldType.SELECT,
    inputName: "projectId",
    label: "project.select_project_to_compare",
    dropdownOptions: projectOptions,
    handleLoadMore: hasNextPage ? handleLoadMore : undefined,
    onChange: (e: any) => dispatch(setCompareProjectId(String(e?.target?.value ?? ""))),
  };

  return (
    <section>
      <div className="module-group d-flex f-column gap-8">
        <div className="pos-relative pb-1">
          <h2 className="fs-14 ff-medium-ext module-header w-fit">
            <TranslatableText translationKey="project.project_comparison" />
          </h2>
        </div>
        <Formik initialValues={{ projectId: "" }} onSubmit={() => {}}>
          <Form className="w-100" style={{ maxWidth: "500px" }}>
            <GenericInputGroup inputGroup={{ ...dropdownInput }} showCommentIcon={false} />
          </Form>
        </Formik>
      </div>
    </section>
  );
};

const ProjectCompare = () => {
  const { tabsOpen, compareProjectId } = useAppSelector(selectCurrentBuilder);

  return !tabsOpen ? (
    compareProjectId ? (
      <ProjectResults projectId={compareProjectId} isCompare />
    ) : (
      <SelectProjectToCompare />
    )
  ) : null;
};

export default ProjectCompare;
